// extracted by mini-css-extract-plugin
module.exports = {"progress":"style_progress__SEC92","big":"style_big__k8sVm","indicator":"style_indicator__2uEGa","background":"style_background__3ThVn","move":"style_move__1FTU9"};